<template>
  <amplify-authenticator username-alias="email">
    <div id="app">
      <router-view v-if="signedIn" />
    </div>
  </amplify-authenticator>
</template>

<script>
import { onAuthUIStateChange } from "@aws-amplify/ui-components";

export default {
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.$store.commit("set", ["user", authData]);

      if (this.signedIn) {
        this.fetchLocations();
      }
    });
  },
  beforeUnmount() {
    this.unsubscribeAuth();
  },
  // components: {
  //   LoadingApp
  // },
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
    };
  },
  computed: {
    signedIn() {
      return this.authState && this.authState === "signedin";
    },
  },
  methods: {
    async fetchLocations() {
      const response = await this.$store.dispatch("callAPI", {
        action: "getLocations",
      });
      this.$store.commit("set", ["locations", response.data.data]);
    },
  },
};
</script>
<style>
/* Compact toast notifications */
.copy-toast {
  padding: 6px 12px !important;
  min-height: auto !important;
  font-size: 11px !important;
  border-radius: 4px !important;
}

.copy-toast .Vue-Toastification__toast-body {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
